import React from "react";
import "./css/Backdrop.css";

const Backdrop = props => {
  return <div className="backdrop image"></div>;
};

export default Backdrop;
